import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/styles';

import TextField from '../fields/TextField';

const RailwayForm = ({ classes, error, handleSubmit, pristine, submitting }) => (
  <form onSubmit={handleSubmit}>
    {error && <Typography variant="subtitle1">{error}</Typography>}

    <Field
      name="name"
      component={TextField}
      label="Naam"
      fullWidth
      id="ride_name"
      disabled
    />

    <Field
      name="phone-number"
      component={TextField}
      label="Phone number"
      fullWidth
      id="ride_phone_number"
    />

    <CardActions className={classes.cardActions}>
      <Button
        disabled={pristine || submitting}
        variant="contained"
        color="primary"
        type="submit"
      >Bewerk rit</Button>
    </CardActions>
  </form>
);

RailwayForm.propTypes = {
  error: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

RailwayForm.defaultProps = {
  error: undefined,
};

export default connect(null, {})(reduxForm({
  form: 'RailwayForm',
})(withStyles({
  cardActions: {
    marginTop: 20,
    width: '100%',
  },
})(RailwayForm)));
